<template>
  <div id="top">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm6 class="slider">
            <v-carousel hide-delimiters hide-controls height="400">
              <v-carousel-item v-for="(item, i) in art" :key="i" :src="item.src">
                <div class="slide-footer">
                  <div v-html="item.text"></div>        
                </div>               
              </v-carousel-item>
            </v-carousel>
        </v-flex>
        <v-flex xs12 sm6 class="bg-cream">
          
            <v-carousel hide-delimiters hide-controls height="400">
              <v-carousel-item v-for="(text, i) in greetings" :key="i">
                  <v-card light flat class="bg-cream">
                    <v-card-text>
                      <h2 class="secondary--text slider-title mt-5 text-xs-center">{{text.title}}</h2>
                      <div class="slider-logn-text mt-4 px-2 text-justify" v-html="text.longText"></div>
                    </v-card-text>
                  </v-card>
              </v-carousel-item>
            </v-carousel>
        </v-flex>          
      </v-layout>
    </v-container>
  </div>
</template>

<script>
    export default {
      name: 'Top',
        data: () => ({
            art: [
              { 
                src: '/img/slides/slide1.jpg',
                text: '<span>Evening Boats. Les Iles du Frioul</span> Oil on canvas, 30x70cm'
              },
              { 
                src: '/img/slides/slide2.png',
                text: '<span>Backstage at the Bolshoi</span> oil on board, 40X50cm'
              },
              { 
                src: '/img/slides/slide3.png',
                text: '<span>"Silver lining"</span> watercolour, 30X40cm'
              },
              { 
                src: '/img/slides/slide4.png',
                text: '<span>Birch Forest near Moscow</span> oil on canvas, 45X60cm'
              },
              { 
                src: '/img/slides/slide5.png',
                text: '<span>Still-life with a blue jug</span> oil on canvas, 40X50cm'
              },
              { 
                src: '/img/slides/slide6.jpg',
                text: '<span>On the veranda</span> oil on panel, 40x50cm'
              },
              { 
                src: '/img/slides/slide7.jpg',
                text: '<span>Sonia</span> Oil on panel, 40x50cm'
              },
              { 
                src: '/img/slides/slide8.png',
                text: '<span>Pultney Bridge at dusk</span> oil on board, 30X40cm'
              },                                                                                    
            ],
            greetings: [
              {
                title: 'Welcome to the site of Maria Danishvar Brown',
                longText: 'Cosmopolitan painter from Russia who lives and works in Bath, UK. Maria is a figurative artist specialising in portraiture and teaching,             A-level coaching and inspiring children. <br><br>Maria is also a semi-professional classical singer (opera, oratorio & song) and performs regularly as a soloist in concerts in the South West.'
              },              
              {
                title: 'Добро пожаловать на сайт Марии Данишвар Браун',
                longText: 'Сайт художницы с богатой и сложной палитрой, вдохновляемой разными сюжетами из жизни и работающей в городе Бат, Великобритании.<br> <br>Пройдя в России серьезную школу классического реализма, Мария специализируется в портрете и с легкостью использует различные материалы для работы в разных жанрах.<br><br> Будучи профессиональным и увлеченным преподавателем, она с успехом развивает творческие способности детей и готовит школьников к выпускным экзаменам A-level'
              },
              {
                title: 'Bienvenue sur le site de Maria Danishvar Brown',
                longText: 'Une artiste de sentiments et sensibilités très ouverte aux multiples talents d\'expression variés venu de Russie.<br><br> Aujourd\'hui elle vit et travaille à Bath, au Royaume-Uni Maria est une artiste figurative, se spécialisant dans les portraits et l\'enseignement de l\'art, apprentissage des méthodes de travail, ainsi que l\'animation artistique avec les enfants'
              },
              {
                title: 'Willkommen auf der Website von Maria Danishvar Brown',
                longText: 'Einer Künstlerin aus Russland, die in Bath, Grossbritanien, lebt und arbeitet. Maria spezialisiert sich im Bereich Figurative Malerei mit dem             Schwerpunkt - Portrait. Für die Kinder bietet Maria Unterricht auf höchstem Niveau'
              }
            ]
          })
      }
</script>

<style>
  #top {
    margin-top: 50px;
    background-color: #b4b6b0!important;
  }
  #top h1 {
    font-size: 22px;
    font-family: WalkwayBoldRegular;
    color: #342b19;
  }
  .fade-enter { 
    opacity: 0; 
  }
  .fade-enter-active { 
    transition: 1s; 
  }
  .fade-leave-active { 
    transition: 1s; opacity: 0; 
  }
  .slider {
    position: relative;
    margin: auto!important;
    border-right: 5px solid #b4b6b0!important;
  }
  .slider-title {
    font-family:  'Open Sans Condensed', sans-serif!important;
  }
  .slide-footer {
    position: absolute;
    opacity: 0.6;
    font-family: 'Open Sans Condensed', sans-serif;
    background-color: rgb(53, 48, 48);
    width: 100%;
    padding: 5px 10px;
    bottom: 0;
    left: 0;
    color: #fff;
    font-size: 14px;
  }
  .slide-footer span {
    font-size: 20px; 
    font-weight: bold;
  }

  #top .slider-logn-text {
    font-size: 16px;
    font-family: Aial, Helvetica, sans-serif;
  }

@media (max-width: 1260px) {
  #top .slider-logn-text {
    font-size: 14px !important;
  }
}

@media (max-width: 768px) {
  #top .slider-logn-text {
    font-size: 12px !important;
  }
}

@media (max-width: 600px) {
  .slider {
    border: none!important;
  }
}
</style>